// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1DcVH","header":"ReportDetails_header__1qY6D","title":"ReportDetails_title__2GvkG","left":"ReportDetails_left__3oFk1"};